var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-input-table',_vm._g(_vm._b({attrs:{"server":{ params: { paging: { pageSize: 3 } } },"data":{
        'enable-text-add': _vm.$_('w_QuickList_CreateItem', [
            _vm.$_(_vm.meta.attr.tagMap['uiLabel']),
        ]),
        'enable-text-edit': _vm.$_('w_QuickList_EditItem', [
            _vm.$_(_vm.meta.attr.tagMap['uiLabel']),
        ]),
    },"interfaces":_vm.infs},on:{"on-add":_vm.doAdd,"on-edit":_vm.doEdit,"on-delete":_vm.doDelete}},'iv-base-input-table',{ ..._vm.$attrs, ..._vm.$props, value: _vm.innateValue },false),{ ..._vm.$listeners }))
}
var staticRenderFns = []

export { render, staticRenderFns }